import React, { useState, Fragment } from 'react';
import { Calendar } from 'primereact/calendar';
import FilterBy from './filterBy';
import { Button } from 'primereact/button';
import { timesheetApi } from '../../services';
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";

function Filter(props) {
    const [showFilterBy, setShowFilterBy] = useState(false);
    const [calDate, setCalDate] = useState(null);
    const [dateRange, setDateRange] = useState({});
    const user = useSelector(selectUser);
    const fullURL = window.location.href;
    const url = new URL(fullURL);
    const empTimelineId = url.searchParams.get('id') || user.id;

    const setDuration = async (type) => {
        let todayDate = new Date();
        let fromDate;
        let startDate;
        let endDate;

        if (type === "currentWeek") {
            fromDate = new Date(todayDate);
            fromDate.setDate(todayDate.getDate() - 6);
            startDate = fromDate;
            endDate = todayDate;

        } else if (type === "last3weeks") {
            fromDate = new Date(todayDate);
            fromDate.setDate(todayDate.getDate() - 20);
            startDate = fromDate;
            endDate = todayDate;
        } else if (calDate && calDate.length === 2) {
            startDate = calDate[0];
            endDate = calDate[1];
        } else {
            return;
        }
        try {
            const projectData = {
                userId: empTimelineId,
                startDate: moment(startDate).format('YYYY-MM-DD'),
                endDate: moment(endDate).format('YYYY-MM-DD'),
            };
            setDateRange(projectData)
            const resp = await timesheetApi.getProjectByUserId(projectData);
            const data = resp.data.data;
            props.updateTimeLine(data);
        } catch (err) {
            console.error(err);
        }
    };

    const updateInFilterBy = async (obj) => {
        var dataObj = {
            userId: empTimelineId,
            ...obj.projectTitle && { projectTitle: obj.projectTitle },
            isBillable: obj.isBillable === true,
            isNonBillable: obj.isNonBillable === true,
        };
        if (obj.startDate) dataObj = { ...dataObj, startDate: obj.startDate }
        if (obj.endDate) dataObj = { ...dataObj, endDate: obj.endDate }
        if (dataObj.bench && !dataObj.isBillable) delete dataObj.isBillable;
        if (dataObj.bench && !dataObj.isNonBillable) delete dataObj.isNonBillable;
        if (dataObj.projectTitle && !dataObj.isBillable && !dataObj.isNonBillable) {
            delete dataObj.isBillable;
            delete dataObj.isNonBillable
        }
        try {
            if (Object.keys(dataObj).length === 3 && !dataObj.isBillable && !dataObj.isNonBillable) {
                delete dataObj.isBillable;
                delete dataObj.isNonBillable
            }
            const resp = await timesheetApi.getProjectByUserId(dataObj);
            const data = resp.data.data;
            props.updateTimeLine(data);
        } catch (err) {
            console.error(err);
        }
    };

    const onCalendarHide = () => {
        try {
            if (calDate && calDate.length === 2) {
                const newDateRange = {
                    startDate: moment(calDate[0]).startOf('day').format('YYYY-MM-DD'),
                    endDate: moment(calDate[1]).startOf('day').format('YYYY-MM-DD')
                };
                props.onSelection(newDateRange);
            } else {
                console.error("Invalid calendar date range");
            }
        } catch (e) {
            console.error(e);
        }
    };

    const changeOnCustom = async (e) => {
        setCalDate(e.value);
        // if (e.value[1]) {
        //     document.getElementsByClassName("p-datepicker")[0].style.display = "none";
        // }
    }

    return (
        <Fragment>
            <div className="header">
                <Button label="Current Week" icon="pi pi-calendar" className="timeline-button-header" onClick={() => setDuration("currentWeek")} />
                <Button label="Last 3 Weeks" icon="pi pi-calendar-times" className="timeline-button-header" onClick={() => setDuration("last3weeks")} />
                <Calendar placeholder="Select Period" id="range" selectionMode="range" readOnlyInput showButtonBar showIcon icon="pi pi-calendar" onHide={onCalendarHide} value={calDate} onChange={(e) => changeOnCustom(e)} className="calendar-input" dateFormat="dd/mm/yy" mask="99/99/9999" />
                <Button label={showFilterBy ? 'Hide Filter' : 'Show Filter'} icon="pi pi-sliders-h" className="timeline-button-header" onClick={() => setShowFilterBy(!showFilterBy)} />
            </div>
            <FilterBy show={showFilterBy} onFilterByChange={updateInFilterBy} dateRange={dateRange} />
        </Fragment>
    );
}

export default Filter;